module.exports = __webpack_public_path__ + "img/27.7.Chla.24f34a60.png";